import { useNavigate } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useCreatePerformer } from "../api/queries";
import { PerformerForm } from "../ui/PerformerForm";

export function PerformerCreatePage() {
  const nav = useNavigate({ from: "/app/performance/performers/create" });
  const createPerformer = useCreatePerformer();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ນັກສະແດງ", to: "/app/performance/performers" },
            { label: "ເພີ່ມໃໝ່" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">ເພີ່ມນັກສະແດງ</h2>
          <p className="text-muted-foreground">ເພີ່ມຂໍ້ມູນນັກສະແດງໃໝ່ໃນລະບົບ.</p>
        </div>

        <div className="rounded-xl border bg-card px-6">
          <PerformerForm
            onSubmit={async (vals) => {
              try {
                const created = await createPerformer.mutateAsync(vals);
                nav({
                  to: "/app/performance/performers/$id",
                  params: { id: created.id },
                });
              } catch {}
            }}
            onCancel={() => nav({ to: "/app/performance/performers" })}
            submitting={createPerformer.isPending}
          />
        </div>
      </Main>
    </>
  );
}
